module.exports = "<angular2-fullcalendar #scheduleCalendar [options]=\"calendarOptions\"></angular2-fullcalendar>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/fullcalendar/fullcalendar.template.html
// module id = 1419
// module chunks = 9